import React from 'react';
import GridFilterItem from '../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../Base/Enums/GridFilterItemType.enum';
import GridFilter from '../../../Base/Components/GridFilter/GridFilter';
import { useAppContext } from '../../../../Services/AppContext';
import useFilters from '../../../Base/Hooks/useFilters';
import { GRID_FILTER_KEYS } from '../../../Base/Components/GridFilter/gridFilterKeys';
import useScope from '../../../Scope/Hooks/useScope';
import { WorkplacePatientStatus } from '../../../../graphql/graphql';

export interface EArchiveListFilterValues {
	fulltext?: string;
	doctorId?: string;
	status?: WorkplacePatientStatus;
	healthPlanIds?: string[];
	workplaceId?: string;
	insuranceCompanyIds?: string[];
}

export interface EArchiveListExcludeFilterFields {
	status: boolean;
}

interface Props {
	onFilter: (values: EArchiveListFilterValues) => void;
	excludeFilterFields?: EArchiveListExcludeFilterFields;
}

const EArchiveListFilter: React.FC<Props> = ({
	onFilter,
	excludeFilterFields,
}) => {
	const { workplaceId, isLatam } = useAppContext();
	const { handleSelectValue, handleMultiSelectValue } = useFilters();
	const { isHungary } = useScope();

	const onFilterData = (values: any) => {
		const filter: EArchiveListFilterValues = {
			fulltext: values?.fulltext,
			doctorId: handleSelectValue(values?.doctor?.value),
			status: values?.workplacePatientStatus?.value,
			healthPlanIds: handleMultiSelectValue(values?.healthPlanIds),
			insuranceCompanyIds: handleMultiSelectValue(values.insuranceCompanies),
			workplaceId,
		};
		onFilter(filter);
	};

	return (
		<GridFilter
			onChange={onFilterData}
			storageKey={GRID_FILTER_KEYS.EARCHIVE_FILTER}>
			<GridFilterItem
				type={GridFilterItemType.FULLTEXT}
				width={700}
				customLabel='base.shared.searchPatient'
				customPlaceholder='doctor.centralEvidenceScreen.patientSearchDescription'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.DOCTOR_ID}
				width={430}
				customLabel='base.shared.searchDriver'
				customPlaceholder='placeholders.enterLastName'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.INSURANCE_COMPANIES}
				contentWidth={200}
				enableAutocomplete
				visible={!isLatam && !isHungary}
			/>
			{!excludeFilterFields?.status ? (
				<GridFilterItem
					type={GridFilterItemType.WORKPLACE_PATIENT_STATUS}
					width={280}
					enableAutocomplete
				/>
			) : (
				<></>
			)}
			<GridFilterItem
				type={GridFilterItemType.HEALTH_PLAN_IDS}
				width={320}
				enableAutocomplete
				visible={!isHungary}
			/>
		</GridFilter>
	);
};

export default EArchiveListFilter;
